var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "basic-form-container" }, [
    _c(
      "div",
      { staticClass: "left-section" },
      [
        _c(
          "el-form-item",
          { attrs: { label: "点餐开票" } },
          [
            _c(
              "el-select",
              {
                staticClass: "full-width",
                attrs: { placeholder: "请选择销方信息" },
                model: {
                  value: _vm.formData.invoiceOrder,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "invoiceOrder", $$v)
                  },
                  expression: "formData.invoiceOrder",
                },
              },
              _vm._l(_vm.invoiceCompanyOptions, function (invoiceCompany) {
                return _c("el-option", {
                  key: invoiceCompany.taxCode,
                  attrs: {
                    label: invoiceCompany.title,
                    value: invoiceCompany.taxCode,
                  },
                })
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "充值开票" } },
          [
            _c(
              "el-select",
              {
                staticClass: "full-width",
                attrs: { placeholder: "请选择销方信息" },
                model: {
                  value: _vm.formData.invoiceRecharge,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "invoiceRecharge", $$v)
                  },
                  expression: "formData.invoiceRecharge",
                },
              },
              _vm._l(_vm.invoiceCompanyOptions, function (invoiceCompany) {
                return _c("el-option", {
                  key: invoiceCompany.taxCode,
                  attrs: {
                    label: invoiceCompany.title,
                    value: invoiceCompany.taxCode,
                  },
                })
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "购券开票" } },
          [
            _c(
              "el-select",
              {
                staticClass: "full-width",
                attrs: { placeholder: "请选择销方信息" },
                model: {
                  value: _vm.formData.invoiceCoupon,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "invoiceCoupon", $$v)
                  },
                  expression: "formData.invoiceCoupon",
                },
              },
              _vm._l(_vm.invoiceCompanyOptions, function (invoiceCompany) {
                return _c("el-option", {
                  key: invoiceCompany.taxCode,
                  attrs: {
                    label: invoiceCompany.title,
                    value: invoiceCompany.taxCode,
                  },
                })
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "发票类型" } },
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.formData.invoiceType,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "invoiceType", $$v)
                  },
                  expression: "formData.invoiceType",
                },
              },
              [
                _c("el-radio", { attrs: { label: 0 } }, [_vm._v("普票")]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: 1 } }, [_vm._v("专票")]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: 2 } }, [_vm._v("电专")]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: 3 } }, [_vm._v("电普")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "点餐模式" } },
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.formData.orderMode,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "orderMode", $$v)
                  },
                  expression: "formData.orderMode",
                },
              },
              [
                _c("el-radio", { attrs: { label: 1 } }, [_vm._v("快餐")]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: 2 } }, [_vm._v("中餐")]),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "right-section" },
      [
        _c(
          "el-form-item",
          { attrs: { label: "启用充值" } },
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.formData.canRecharge,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "canRecharge", $$v)
                  },
                  expression: "formData.canRecharge",
                },
              },
              [
                _c("el-radio", { attrs: { label: 0 } }, [_vm._v("关闭")]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "启用余额" } },
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.formData.canSurplus,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "canSurplus", $$v)
                  },
                  expression: "formData.canSurplus",
                },
              },
              [
                _c("el-radio", { attrs: { label: 0 } }, [_vm._v("关闭")]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          { attrs: { label: "游客模式" } },
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.formData.visitorMode,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "visitorMode", $$v)
                  },
                  expression: "formData.visitorMode",
                },
              },
              [
                _c("el-radio", { attrs: { label: 0 } }, [_vm._v("关闭")]),
                _vm._v(" "),
                _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "tourist-tip" }, [
          _vm._v("游客模式：启用游客模式后，顾客可以匿名方式免登录点餐"),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }